<script setup>
import SettingsDataRemovalPageNew from "@/routes/Pages/SettingsDataRemovalPageNew.vue";
</script>

<template>
  <SettingsDataRemovalPageNew />
</template>
